//#region INTERFACE IApplicationTooltips
export interface IApplicationTooltips {
  addStockItemManualCode: string;
  addStockItemRule: string;
  ccRecipientAdd: string;
  ccRecipientRemove: string;
  defaultExportSettings: string;
  defaultFilters: string;
  defaultOrder: string;
  defaultOrderFormula: string;
  defaultValue: string;
  disableStockItemNotOnHand: string;
  disableStockItemOnHand: string;
  editAccessDenied: string;
  editAccessGranted: string;
  enableStockItem: string;
  enableStockItemDescPrefixRemove: string;
  enableStockItemDescSuffixRemove: string;
  orderSettings: string;
  overrideSettings: string;
  priceBanding: string;
  priceEditsAfterProcessed: string;
  priceThreshold: string;
  saveAllChanges: string;
  saveChanges: string;
  shelfTalkersOverrideSettings: string;
  tagValidTypes: string;
  undoAllChanges: string;
  undoChanges: string;
}

//#endregion

//#region DEFAULT _DEFAULT_APPLICATION_TOOLTIPS
export const _DEFAULT_APPLICATION_TOOLTIPS: Readonly<IApplicationTooltips> = {
  addStockItemManualCode: 'When on, Add Stock Item opens with manual stock code entry ticked so users can type their own code instead of generating one. Users can still change this per item.',
  addStockItemRule: 'Configure prefix, suffix, and digit rules used to generate stock item codes when adding items.',
  ccRecipientAdd: 'Add Additional CC Recipient',
  ccRecipientRemove: 'Remove Additional CC Recipient',
  defaultExportSettings: 'Set default export columns and whether exports include only rows with quantity greater than zero.',
  defaultFilters: 'Set default filters used when opening orders, including quantity and line-colour visibility options.',
  defaultOrder: 'Set default open-order display and calculation options such as supplier handling, line colours, and quantity behaviour.',
  defaultOrderFormula: 'Set the default ordering formula values used to calculate suggested order quantities.',
  defaultValue: 'Default Value',
  disableStockItemOnHand: 'Define how stock items are marked when on-hand quantity is zero, including description, colour, hold code, and supplier action.',
  disableStockItemNotOnHand: 'Define how stock items are marked when on-hand quantity is not zero, including description, colour, hold code, and supplier action.',
  editAccessDenied: 'Edit Access Denied',
  editAccessGranted: 'Edit Access Granted',
  enableStockItem: 'Set the defaults used when enabling stock items, including description cleanup, line colour, hold code, and supplier action.',
  enableStockItemDescPrefixRemove: 'When an item is enabled, any matching prefix found at the start of the description will be removed.',
  enableStockItemDescSuffixRemove: 'When an item is enabled, any matching suffix found at the end of the description will be removed.',
  orderSettings: 'Set the default order details and email content used for auto-ordering.',
  overrideSettings: 'Control global override behaviour for auto-ordering, including whether blank supplier codes can be ordered.',
  priceBanding: 'Set how edited prices snap to a friendlier ending. Rules are checked from top to bottom; the first matching rule is used.',
  priceEditsAfterProcessed: 'Prices can be edited after an order has been processed',
  priceThreshold: 'Set maximum allowed percentage increases and decreases for price changes.',
  saveAllChanges: 'Save All Changes',
  saveChanges: 'Save Changes',
  shelfTalkersOverrideSettings: 'Control whether shelf talkers are generated automatically by default.',
  tagValidTypes: 'Tags can contain letters, numbers, and underscores. Maximum 15 characters.',
  undoAllChanges: 'Undo All Changes',
  undoChanges: 'Undo Changes',
};
//#endregion
